import { StorageKeys } from "@fkhplus/common/src/services/storage/Constants";
import { StorageService } from "@fkhplus/common/src/services/storage/StorageService";
import { Logger } from "@fkhplus/common/src/utils/logger";

const languageDetector = {
    type: 'languageDetector',
    async: true,
    init: () => { },
    detect: async function (callback: (lang: string) => void) {
        try {
            let language = await StorageService.get(StorageKeys.SELECTED_LANGUAGE)

            if (language) {
                return callback(language as string);
            } else {
                return callback('en');
            }
        } catch (error) {
            Logger.error("Error reading language")
        }
    },
    cacheUserLanguage: async function (language: string) {
        try {
            await StorageService.set(StorageKeys.SELECTED_LANGUAGE, language);
        } catch (error) { }
    },
};

export default languageDetector;